import React from 'react';
import { withRouter } from 'react-router-dom';
import ReactGA from 'react-ga';

class Analytics extends React.Component {
  componentDidUpdate({ location, history }) {
    if (location.pathname === this.props.location.pathname) {
      // don't log identical link clicks (nav links likely)
      return;
    }

    if (process.env.REACT_GOOGLE_ANALYTICS_TRACK_ID && history.action === 'PUSH') {
      ReactGA.set({ page: location.pathname }, ['tracker1', 'tracker2']); // Update the user's current page
      ReactGA.pageview(location.pathname, ['tracker1', 'tracker2']); // Record a pageview for the given page
    }

    window.SR.event.pageVisit().then(function () {
      window.SR.dynamicContent.get();
    });
  }

  render() {
    return null;
  }
}

export default withRouter(Analytics);
